import {SmSigningProcessService} from './service/api/sm-signing-process.service';
import {SmCertificateService} from './service/api/sm-certificate.service';
import {SmChannelTypeService} from './service/api/sm-channel-type.service';
import {SmChannelTypeNotificationService} from './service/api/sm-channel-type-notification.service';
import {
    SmSignatureProfileChannelTypeService
} from './service/api/sm-signature-profile-channel-type.service';
import {SmAuditEventService} from './service/api/sm-audit-event.service';
import {SmDocumentVersionService} from './service/api/sm-document-version.service';
import {SmSignatureProfileService} from './service/api/sm-signature-profile.service';
import {SmSignatureProfileRoleService} from './service/api/sm-signature-profile-role.service';
import {ENTITY_SERVICE_REGISTRY} from '../../core/shared/dto/dto-service/entity-service-registry';
import {MvsCrudModeEnum} from '../../core/shared/service/crud/mvs-crud-mode.enum';
import {
    SmSignatureProfileObjectComponent
} from './component/object-components/sm-signature-profile-object/sm-signature-profile-object.component';

export const SM_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['sm.Signature', {route: '/sm/signatures'}],
            ['sm.SignatureGroup', {route: '/sm/signatureGroups'}],
            ['sm.SignatureType', {route: '/sm/signatureTypes'}],
            [
                'sm.SmSignatureProviderConfig',
                {route: '/sm/signatureProviderConfigs'}
            ],
            // The profile carries two child entity types (roles and released channel types), so it is
            // opened as an object page with left navigation instead of being edited inline.
            [
                'sm.SmSignatureProfile',
                {
                    route: '/sm/signatureProfiles',
                    service: SmSignatureProfileService,
                    objectComponent: [
                        {mode: MvsCrudModeEnum.update, component: SmSignatureProfileObjectComponent}
                    ]
                }
            ],
            [
                'sm.SmSignatureProfileRole',
                {route: '/sm/signatureProfileRoles', service: SmSignatureProfileRoleService}
            ],
            // Reading only, and deliberately NOT the workflow route.
            //
            // The generic route /mvsa/sm/signingProcesses is served by SmSigningProcessCrudController
            // (an ObjectCrudController over the bare SmSigningProcessDtoDetail), so it returns the
            // platform `form` object every generic widget and dialog needs. The custom workflow route
            // POST/GET /mvsa/sm/signing/processes returns SmSigningProcessResponseDto, which carries no
            // form at all - which is why widget.service.ts:177 (`form.hasGenericType()`) died on every
            // widget bound to this entity, and why six generically-named fields (certificateDtoName,
            // channelTypeDtoName, contactType, expiresAt, objectType/objectId) stayed dead.
            //
            // All six mutating verbs of the generic route are refused BY NAME by the controller: the
            // evidence chain of a signing process must not be reachable through a generic insert or
            // update. Creation stays POST /mvsa/sm/signing/processes, cancellation POST .../cancel.
            // Every workflow call keeps living on SmSigningApiService, which has its own baseUrl on
            // /sm/signing and is untouched by this repoint.
            ['sm.SmSigningProcess', {route: '/sm/signingProcesses', service: SmSigningProcessService}],
            // Reading only. The generic CREATE is refused by the controller BY NAME, because adding a
            // signer runs an identity capture, a channel-variant admission, an address-origin
            // derivation and an audit entry - all invariants of the signing PROCESS, none of which a
            // generic insert would satisfy. The refusal names the endpoint to use instead
            // (POST /mvsa/sm/signing/processes/{processId}/signers), which is what
            // mvs-sm-signer-create-dialog writes to.
            [
                'sm.SmSigningProcessSigner',
                {route: '/sm/signingProcessSigners'}
            ],
            ['sm.SmCertificate', {route: '/sm/certificates', service: SmCertificateService}],
            ['sm.SmChannelType', {route: '/sm/channelTypes', service: SmChannelTypeService}],
            [
                'sm.SmChannelTypeNotification',
                {route: '/sm/channelTypeNotifications', service: SmChannelTypeNotificationService}
            ],
            [
                'sm.SmSignatureProfileChannelType',
                {
                    route: '/sm/signatureProfileChannelTypes',
                    service: SmSignatureProfileChannelTypeService
                }
            ],
            ['sm.SmAuditEvent', {route: '/sm/auditEvents', service: SmAuditEventService}],
            ['sm.SmDocumentVersion', {route: '/sm/documentVersions', service: SmDocumentVersionService}],
        ],
        multi: true
    }
];
